import {
  CreateExperienceProductTargetingFeDto,
  ExperienceProductTargetingFeDto,
} from "@intelligems/ig-types/fe-only/experience-product-targeting";

export interface IExperienceProductTargetingState {
  isSuccess: boolean;
  experienceProductTargeting: CreateExperienceProductTargetingFeDto[];
  storedExperienceProductTargeting: ExperienceProductTargetingFeDto[];
}

export const initialIExperienceProductTargetingState: IExperienceProductTargetingState =
  {
    isSuccess: false,
    experienceProductTargeting: [],
    storedExperienceProductTargeting: [],
  };
